import React, { useState } from 'react'

// Replacement for window.confirm on destructive anomalies actions (delete
// preset, remove suppression). Shown via useModal().showModal(...). The
// confirm callback may be async — the modal stays open with the button
// disabled until it resolves, and surfaces a failure inline instead of
// closing over a half-done action.
export const ConfirmModal = (props: {
  title: string
  body?: React.ReactNode
  confirmLabel?: string
  hideModal: () => void
  onConfirm: () => Promise<void> | void
}) => {
  const { title, body, hideModal, onConfirm } = props
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const confirm = async () => {
    setSubmitting(true)
    setError(null)
    try {
      await onConfirm()
      hideModal()
    } catch (e: any) {
      setError(e?.message || 'Something went wrong. Try again.')
      setSubmitting(false)
    }
  }

  return (
    <div className="card-body anomalies-confirm-modal">
      <div className="text-dark text-bigger text-bolder m-b-3">{title}</div>

      {body && (
        <div className="text-light text-small m-b-3">{body}</div>
      )}

      {error && <div className="text-danger text-small m-b-2">{error}</div>}

      <div className="row row-end" style={{ gap: 8 }}>
        <button
          type="button"
          className="btn btn-default"
          onClick={hideModal}
          disabled={submitting}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={confirm}
          disabled={submitting}
        >
          {submitting ? 'Working…' : props.confirmLabel ?? 'Delete'}
        </button>
      </div>
    </div>
  )
}
